import { Channel } from 'types/channels'

export const getSelectedAddress = (channelDetails: Channel, selectedProtocol: string) => {
  if (!channelDetails) return ''
  if (selectedProtocol === channelDetails?.protocol) return channelDetails?.address
  return (
    channelDetails?.alternatives?.find(p => p?.protocol === selectedProtocol)?.address ||
    channelDetails?.address
  )
}

export const getSelectedTag = (
  channelDetails: Channel,
  selectedProtocol: string
): string | null => {
  if (!channelDetails) return null
  if (selectedProtocol !== channelDetails?.protocol) {
    const alt = channelDetails?.alternatives?.find(
      _alt => _alt?.protocol?.toLowerCase() === selectedProtocol?.toLowerCase()
    )
    if (alt) return alt?.tag ?? null
  }
  return channelDetails?.tag?.toString() ?? null
}
